import React, { useContext, useState, FC } from "react";
import styled, { css }  from "styled-components";
import { axios } from "../../../config/Axios";
import { PageTitle } from '../../../components/atoms/pageTitle';
import { LIGHT_GRAY, ORANGE_PRIMARY, SHADOW, SHADOW_PRIMARY, TEXT_SECONDARY } from '../../../config/Constants'
import { DivFlex, DivFlexCen, DivFlexCenCen, DivFlexCenEnd, DivFlexNorCen, DivFlexNorEnd, DivFlexSparoCen, DivFlexSpbet } from "../../../components/utility/flex";
import { BORDER_SECONDARY, RED } from "../../../config/Constants";
import { PTextSecondaryCenXS, SpanTextSecondaryS, SpanTextSecondaryXS } from "../../../components/utility/textSecondary";
import { QuestionSet } from "../../../types/questionSet";
import { PTextSecondaryS } from "../../../components/utility/textSecondary";
import { DivWrap } from '../../../components/utility/wrap';
import { APrimaryOrangeButton, APrimaryOrangeButtonL, ASecondaryOrangeButton, ASecondaryOrangeButtonL, DivSecondaryOrangeButtonDisable } from "../../../components/utility/buttons";
import { PTextPrimaryCenL, PTextPrimaryCenM, PTextPrimaryCenS, PTextPrimaryCenXL, PTextPrimaryL, PTextPrimaryM, PTextPrimaryS } from "../../../components/utility/textPrimary";
import { Modal } from "../../../components/atoms/modal";
import { InputSubmitButton, InputTextField, LabelForTextField, PErrorMessage } from "../../../components/utility/form";
import { QuestionSetPrintTimeAndScore } from "../../../types/questionSetPrintTimeAndScore";
import { StringToGradeImg } from "../../../components/atoms/stringToGradeImg";
import { CurrentUserContext, CurrentUser } from "../../../providers/currentUser";
import { Article } from "../../../types/article";
import { ALink } from "../../../components/utility/link";
import { PageTitleWithDubbleLink } from "../../../components/atoms/pageTitleWithDubbleLink";
import { RCTab } from "../../../components/modules/tab";
import { LineStudyPostItem } from "../../../types/lineStudyPostItem";
import { CALC_QUESTION_SET_PRINT_QUESTIONS_SIZE } from "../../../config/Constants";

export type Props = {
  questionSet: QuestionSet;
  initQuestionSetPrintTimeAndScores: QuestionSetPrintTimeAndScore[];
  article: Article|null;
  tabName: 'line' | 'manual';
  lineStudyPostItems: LineStudyPostItem[];
}

export const CalcFoundationShow:FC<Props> = (props:Props) => {
  const { questionSet, initQuestionSetPrintTimeAndScores, article, tabName, lineStudyPostItems } = props;
  const currentUser:CurrentUser = useContext(CurrentUserContext)
  const [showNewForm, setShowNewForm] = useState<boolean>(false)
  const [inputQuestionSetPrintTimeAndScore, setInputQuestionSetPrintTimeAndScore] = useState<QuestionSetPrintTimeAndScore|null>(null);
  const [deleteQuestionSetPrintTimeAndScore, setDeleteQuestionSetPrintTimeAndScore] = useState<QuestionSetPrintTimeAndScore|null>(null);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [questionSetPrintTimeAndScores, setQuestionSetPrintTimeAndScores] = useState<QuestionSetPrintTimeAndScore[]>(initQuestionSetPrintTimeAndScores)

  const closeNewForm = () => {
    setShowNewForm(false)
    setErrorMessages([])
  }

  const timeAndScoreCreate:React.FormEventHandler<HTMLFormElement> = (e) => {
    if(isLoading) return

    setIsLoading(true)
    e.preventDefault();
    setErrorMessages([]);
    const newErrorMessages = []
    if(e.target.min.value === '') {
      newErrorMessages.push('分を入力してください。')
    }
    if(e.target.sec.value === '') {
      newErrorMessages.push('秒を入力してください。')
    }
    if(e.target.missCount.value === '') {
      newErrorMessages.push('ミスを入力してください。')
    }
    setErrorMessages(newErrorMessages);
    if(e.target.min.value === '' || e.target.sec.value == '' || e.target.missCount.value === '') {
      setIsLoading(false)
      return
    }

    axios.post(`/api/question_sets/${questionSet.id}/question_set_print_time_and_scores/create_on_show`, {
      min: (e.target as any).min.value,
      sec: (e.target as any).sec.value,
      missCount: (e.target as any).missCount.value,
    })
    .then(response => {
      if(response.data.errorMessages.length > 0){
        setErrorMessages(response.data.errorMessages)
      } else {
        setQuestionSetPrintTimeAndScores(response.data.questionSetPrintTimeAndScores)
        setShowNewForm(false)
      }
      setIsLoading(false)
    })
    .catch(error => {
      console.log(error);
    })
  }

  const timeAndScoreDeleteModalShow = () => {
    setDeleteQuestionSetPrintTimeAndScore(inputQuestionSetPrintTimeAndScore)
    setInputQuestionSetPrintTimeAndScore(null)
  }

  const timeAndScoreDelete = () => {
    if(isLoading) return

    setIsLoading(true)
    axios.delete(`/api/question_set_print_time_and_scores/${deleteQuestionSetPrintTimeAndScore.id}`)
    .then(response => {
      setQuestionSetPrintTimeAndScores(response.data.questionSetPrintTimeAndScores)
      setDeleteQuestionSetPrintTimeAndScore(null)
      setIsLoading(false)
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false)
    })
  }

  const timeAndScoreUpdate:React.FormEventHandler<HTMLFormElement> = (e) => {
    if(isLoading) return

    e.preventDefault();
    setErrorMessages([]);
    const newErrorMessages = []
    if(e.target.min.value === '') {
      newErrorMessages.push('分を入力してください。')
    }
    if(e.target.sec.value === '') {
      newErrorMessages.push('秒を入力してください。')
    }
    if(e.target.missCount.value === '') {
      newErrorMessages.push('ミスを入力してください。')
    }
    setErrorMessages(newErrorMessages);
    if(e.target.min.value === '' || e.target.sec.value == '' || e.target.missCount.value === '') {
      setIsLoading(false)
      return
    }
    axios.patch(`/api/question_set_print_time_and_scores/${inputQuestionSetPrintTimeAndScore.id}`, {
      min: (e.target as any).min.value,
      sec: (e.target as any).sec.value,
      missCount: (e.target as any).missCount.value,
    })
    .then(response => {
      if(response.data.errorMessages.length > 0){
        setErrorMessages(response.data.errorMessages)
      } else {
        setQuestionSetPrintTimeAndScores(response.data.questionSetPrintTimeAndScores)
        setInputQuestionSetPrintTimeAndScore(null);
      }
      setIsLoading(false)
    })
    .catch(error => {
      console.log(error);
    });
  };

  const questionSetGrade = (questionSet:QuestionSet, timeSec:number, missCount: number, remSize: number) => {
    if(questionSet.sGradeTime ==null || questionSet.aGradeTime ==null || timeSec == null || missCount > 0) return;

    if(timeSec <= questionSet.sGradeTime) {
      return <StringToGradeImg gradeString="S" remSize={remSize} margin={'0 0 0 0.5rem'}/>
    } else if (timeSec <= questionSet.aGradeTime) {
      return <StringToGradeImg gradeString="A" remSize={remSize*1.25} margin={'0 0 0 0.5rem'}/>
    } else {
      return <StringToGradeImg gradeString="B" remSize={remSize*1.125} margin={'0 0 0 0.5rem'}/>
    }
  }

  const sutdyRecordPath = () => {
    if(currentUser.id == null) return(`/study_posts/demo?from=calc_foundation_show&question_set_id=${questionSet.id}`)

    if(currentUser.isDrillSemiMember){
      return `/study_posts?from=calc_foundation_show&question_set_id=${questionSet.id}`
    } else {
      return `/study_posts/demo?from=calc_foundation_show&question_set_id=${questionSet.id}`
    }
  }

  const lineStudyPostItemsDisplay = (lineStudyPostItems: LineStudyPostItem[]) => {
    if(lineStudyPostItems.length > 0) {
      return <>
        <DivWrap>
          {
            lineStudyPostItems.map((lineStudyPostItem, index) => (
                <DivFlexSpbet key={index} style={{borderBottom: `1px solid ${BORDER_SECONDARY}`, padding: '1rem 0.25rem'}}>
                  <DivFlexNorEnd>
                    <SpanTextSecondaryS style={{marginRight: '0.5rem'}}>{lineStudyPostItem.date}</SpanTextSecondaryS>
                    <PTextPrimaryL>{String(Math.floor(lineStudyPostItem.timeSec/60)).padStart(2, '0')}<SpanTextSecondaryS>分</SpanTextSecondaryS>{String(lineStudyPostItem.timeSec%60).padStart(2, '0')}<SpanTextSecondaryS>秒</SpanTextSecondaryS></PTextPrimaryL>
                    <PTextPrimaryL>{lineStudyPostItem.missCount}<SpanTextSecondaryS>ミス</SpanTextSecondaryS></PTextPrimaryL>
                    {questionSetGrade(questionSet, lineStudyPostItem.timeSec, lineStudyPostItem.missCount, 0.75)}
                  </DivFlexNorEnd>
                  <ALink href={`/line_user/line_study_post_items/${lineStudyPostItem.id}`} target='_blank'>
                    画像詳細
                    <i className="fas fa-external-link-alt" style={{marginLeft: '0.25rem'}}/>
                  </ALink>
              </DivFlexSpbet>
              )
            )
          }
        </DivWrap>
      </>
    } else {
      return <PTextPrimaryCenM style={{margin: '1rem 0 0 0'}}>記録がありません</PTextPrimaryCenM>
    }
  }

  const ManualStudyRecordItemsDisplay = ({
    questionSetPrintTimeAndScores,
    questionSet,
    setInputQuestionSetPrintTimeAndScore,
  }: {
    questionSetPrintTimeAndScores: QuestionSetPrintTimeAndScore[];
    questionSet: QuestionSet;
    setInputQuestionSetPrintTimeAndScore: (score: QuestionSetPrintTimeAndScore) => void;
  }) => (
    <>
      <DivButtonWrap style={{margin: '2rem 0 0 0'}}>
        {
          currentUser.id !== null
          ? <APrimaryOrangeButtonL onClick={() => setShowNewForm(true)}>記録する</APrimaryOrangeButtonL>
          :<>
            <DivSecondaryOrangeButtonDisable>記録する</DivSecondaryOrangeButtonDisable>
            <DivFlexCenCen>
              <PTextSecondaryCenXS>
                会員登録が必要です
              </PTextSecondaryCenXS>
            </DivFlexCenCen>
          </>
        }
      </DivButtonWrap>
      <DivFlexCenCen style={{margin: '0.25rem 0 2rem'}}><PTextPrimaryS style={{color: ORANGE_PRIMARY}}>タイムなどを記録することができます</PTextPrimaryS></DivFlexCenCen>
      {
        questionSetPrintTimeAndScores.length === 0
        && <PTextPrimaryCenM style={{margin: '1rem 0 0 0'}}>
          記録がありません</PTextPrimaryCenM>
      }
      {
        questionSetPrintTimeAndScores.map((questionSetPrintTimeAndScore, index) => (
          <DivFlexSpbet key={index} style={{borderBottom: `1px solid ${BORDER_SECONDARY}`, padding: '1rem 0.25rem'}}>
            <DivFlexNorEnd>
              <SpanTextSecondaryS style={{marginRight: '0.5rem'}}>{questionSetPrintTimeAndScore.date}</SpanTextSecondaryS>
              <PTextPrimaryL>{String(Math.floor(questionSetPrintTimeAndScore.timeSec/60)).padStart(2, '0')}<SpanTextSecondaryS>分</SpanTextSecondaryS>{String(questionSetPrintTimeAndScore.timeSec%60).padStart(2, '0')}<SpanTextSecondaryS>秒</SpanTextSecondaryS></PTextPrimaryL>
              <PTextPrimaryL>{questionSetPrintTimeAndScore.missCount}<SpanTextSecondaryS>ミス</SpanTextSecondaryS></PTextPrimaryL>
              {questionSetGrade(questionSet, questionSetPrintTimeAndScore.timeSec, questionSetPrintTimeAndScore.missCount, 0.75)}
            </DivFlexNorEnd>
            <DivButtonWrap>
              <ASecondaryOrangeButton onClick={() => setInputQuestionSetPrintTimeAndScore(questionSetPrintTimeAndScore)}>
                編集<i className="fas fa-pencil-alt" style={{marginLeft: '0.25rem'}}/>
              </ASecondaryOrangeButton>
            </DivButtonWrap>
          </DivFlexSpbet>
        ))
      }
    </>
  );


  return(
    <>
      <PageTitleWithDubbleLink text={questionSet.title} rightWord={'トップ'} rightLinkPath={'/menu/study'} leftWord="戻る" leftLinkPath={`/calc_foundations?question_set_id=${questionSet.id}`} positionSticky={true}/>

      <DivWhiteBackGround/>
      <DivWrap>
        {
          currentUser.id !== null
          ? null
          : <DivFlexCenCen style={{margin: '2rem'}}>
            <ASecondaryOrangeButton style={{width: '12rem'}} href={'/users/new'}>会員登録はこちら</ASecondaryOrangeButton>
          </DivFlexCenCen>
        }
        <DivWrap>
          <PTextPrimaryCenXL style={{marginTop: '3rem'}}>
            プリントを印刷
          </PTextPrimaryCenXL>
          <DivFlexCen style={{marginTop: '2rem' , padding: '0 1rem'}}>
            <DivButtonWrap style={{marginRight: '1rem', flex: 1}}>
                {
                  currentUser.id !== null
                  ? <>
                    <ASecondaryOrangeButtonL href={`/calc_question_sets/${questionSet.id}/question_set_prints/new`} target='_blank'>1枚ずつ<i className="fas fa-external-link-alt"/></ASecondaryOrangeButtonL>
                  </>
                  :<>
                    <DivSecondaryOrangeButtonDisable>1枚ずつ<i className="fas fa-external-link-alt"/></DivSecondaryOrangeButtonDisable>
                  </>
                }
              </DivButtonWrap>
              <DivButtonWrap style={{flex: 1}}>
                {
                  currentUser.id !== null
                  ? <ASecondaryOrangeButtonL href={`/calc_question_sets/${questionSet.id}/question_set_prints/combined_pdf`} target='_blank'>まとめて<i className="fas fa-external-link-alt"/></ASecondaryOrangeButtonL>
                  : <><DivSecondaryOrangeButtonDisable>まとめて<i className="fas fa-external-link-alt"/></DivSecondaryOrangeButtonDisable></>
                }
              </DivButtonWrap>
            </DivFlexCen>
            {
              currentUser.id == null
                ? <DivFlexCenCen style={{marginTop: '0.25rem'}}>
                <PTextSecondaryCenXS>
                  会員登録が必要です
                </PTextSecondaryCenXS>
              </DivFlexCenCen>
              : <DivFlexCenCen style={{marginTop: '0.25rem'}}><PTextPrimaryS style={{color: ORANGE_PRIMARY}}>答え合わせは問題プリント内のQRコードへ</PTextPrimaryS></DivFlexCenCen>
            }
            <DivWrap style={{padding: '0 1rem'}}>
              <DivShadowBox style={{marginTop: '2rem'}}>
                <PTextSecondaryS>
                  <i className="far fa-clock" style={{marginRight: '0.5rem'}}/>
                  目標タイム
                </PTextSecondaryS>
                <DivFlex>
                  <PTextSecondaryS style={{margin: '0 0.5rem 0 0'}}>
                    Sタイム:
                  </PTextSecondaryS>
                  <DivFlexNorEnd>
                    <PTextSecondaryS>{String(Math.floor(questionSet.sGradeTime/60)).padStart(2, '0')}</PTextSecondaryS>
                    <SpanTextSecondaryS>分</SpanTextSecondaryS>
                    <PTextSecondaryS>{String(Math.floor(questionSet.sGradeTime%60)).padStart(2, '0')}</PTextSecondaryS>
                    <SpanTextSecondaryS>秒</SpanTextSecondaryS>
                  </DivFlexNorEnd>
                  <PTextSecondaryS style={{margin: '0 0.5rem 0 1rem'}}>
                    Aタイム:
                  </PTextSecondaryS>
                  <DivFlexNorEnd>
                    <PTextSecondaryS>{String(Math.floor(questionSet.aGradeTime/60)).padStart(2, '0')}</PTextSecondaryS>
                    <SpanTextSecondaryS>分</SpanTextSecondaryS>
                    <PTextSecondaryS>{String(Math.floor(questionSet.aGradeTime%60)).padStart(2, '0')}</PTextSecondaryS>
                    <SpanTextSecondaryS>秒</SpanTextSecondaryS>
                  </DivFlexNorEnd>
                </DivFlex>
              </DivShadowBox>
            </DivWrap>
          {
            article !== null
            && <><PTextPrimaryCenL style={{margin: '2rem 0 0 0'}}>
            参考記事
          </PTextPrimaryCenL>
          <DivFlexCen>
            <ALink href={article.detailPath} target='_blank'>{article.title}<i className="fas fa-external-link-alt"/><i className=""/></ALink>
          </DivFlexCen>
          </>
          }
          <DivRecordsWrap>
            <PTextPrimaryCenXL>
              記録
            </PTextPrimaryCenXL>
            <DivFlexCenEnd style={{margin: '0 0 1rem 0'}}>
              <PTextPrimaryCenM style={{marginRight: '0.5rem'}}>最高記録</PTextPrimaryCenM>
              <DivFlexCen>
                {
                  questionSet.bestTimeAndScore !== null
                  ? <>
                      <DivFlexSpbet style={{padding: '0'}}>
                        <DivFlexNorEnd>
                          <SpanTextSecondaryS style={{marginRight: '0.5rem'}}>{questionSet.bestTimeAndScore.date}</SpanTextSecondaryS>
                          <PTextPrimaryL>{String(Math.floor(questionSet.bestTimeAndScore.timeSec/60)).padStart(2, '0')}<SpanTextSecondaryS>分</SpanTextSecondaryS>{String(questionSet.bestTimeAndScore.timeSec%60).padStart(2, '0')}<SpanTextSecondaryS>秒</SpanTextSecondaryS></PTextPrimaryL>
                          <PTextPrimaryL>{questionSet.bestTimeAndScore.missCount}<SpanTextSecondaryS>ミス</SpanTextSecondaryS></PTextPrimaryL>
                          {questionSetGrade(questionSet, questionSet.bestTimeAndScore.timeSec, questionSet.bestTimeAndScore.missCount, 0.75)}
                        </DivFlexNorEnd>
                      </DivFlexSpbet>
                  </>
                  : <PTextPrimaryS>記録がありません</PTextPrimaryS>
                }
              </DivFlexCen>
            </DivFlexCenEnd>
            <RCTab tabElementStates={
              [
                {
                  tabKey: 'manual',
                  tabName: '手動入力',
                  tabPath: `/calc_foundations/${questionSet.id}`,
                  selected: tabName === 'manual',
                },
                {
                  tabKey: 'line',
                  tabName: 'LINE投稿記録',
                  tabPath: `/calc_foundations/${questionSet.id}?tab=line`,
                  selected: tabName === 'line',
                },
              ]
            }/>
            {
              tabName === 'line' && lineStudyPostItemsDisplay(lineStudyPostItems)
            }
            {
              tabName === 'manual' &&
              <ManualStudyRecordItemsDisplay
                questionSetPrintTimeAndScores={questionSetPrintTimeAndScores}
                questionSet={questionSet}
                setInputQuestionSetPrintTimeAndScore={setInputQuestionSetPrintTimeAndScore}
              />
            }
          </DivRecordsWrap>
        </DivWrap>
      </DivWrap>
      <DivAdviceWrap>
        <PTextPrimaryCenXL style={{marginBottom: '2rem'}}>
          アドバイスをもらおう
        </PTextPrimaryCenXL>
        <APrimaryOrangeButtonL href={sutdyRecordPath()}>
          <i className="far fa-comments" style={{marginRight: '0.5rem'}}/>
          学習添削へ
        </APrimaryOrangeButtonL>
        <DivFlexCenCen style={{margin: '0.25rem 0 2rem'}}>
          <PTextPrimaryCenS style={{color: ORANGE_PRIMARY}}>
            取り組んだプリントを送って
            <br/>
            先生からアドバイスをもらうことができます！
          </PTextPrimaryCenS>
        </DivFlexCenCen>
      </DivAdviceWrap>
      <Modal
        isModalShow = {showNewForm}
        closeAction={closeNewForm}
      >
        <>
          <PTextPrimaryL style={{marginBottom: '0.75rem'}}>{  questionSet.title}</PTextPrimaryL>
          <form onSubmit={timeAndScoreCreate}>
            <LabelForTextField style={{fontSize: '0.875rem'}} htmlFor="min">タイム・ミスの数</LabelForTextField>
            <DivFlexCenEnd>
              <InputTextField name={'min'} type={'number'} min="0" max="100"/>
              <SpanTextSecondaryXS style={{padding: '0.125rem'}}>分</SpanTextSecondaryXS>
              <InputTextField name={'sec'} type={'number'} min="0" max="59"/>
              <SpanTextSecondaryXS style={{padding: '0.125rem'}}>秒</SpanTextSecondaryXS>
              <InputTextField name={'missCount'} type={'number'} min="0" max="25"/>
              <SpanTextSecondaryXS style={{padding: '0.125rem'}}>ミス</SpanTextSecondaryXS>
            </DivFlexCenEnd>
            {
              errorMessages.length > 0
              && <>
                { errorMessages.map((errorMessage, index) => (
                    <PErrorMessage key={index}>
                      {errorMessage}
                    </PErrorMessage>
                  ))
                }
              </>
            }
            <InputSubmitButton value={ isLoading ? '記録中...' : '記録'} type="submit" disabled={isLoading}/>
          </form>
        </>
      </Modal>
      <Modal
        isModalShow={inputQuestionSetPrintTimeAndScore != null}
        closeAction={() => setInputQuestionSetPrintTimeAndScore(null)}
      >
        <>
          {
            inputQuestionSetPrintTimeAndScore != null &&
            <>
              <DivFlexNorCen>
                <PTextPrimaryM>{ inputQuestionSetPrintTimeAndScore.date}</PTextPrimaryM>
                <span onClick={timeAndScoreDeleteModalShow} style={{cursor: 'pointer', color: RED, fontSize: '1rem'}}><i className="fas fa-trash-alt" style={{marginLeft: '0.25rem'}}/></span>
              </DivFlexNorCen>

              <PTextPrimaryL style={{marginBottom: '0.75rem'}}>{  questionSet.title}</PTextPrimaryL>
              <form onSubmit={timeAndScoreUpdate}>
                <LabelForTextField style={{fontSize: '0.875rem'}} htmlFor="min">タイム・ミスの数</LabelForTextField>
                <DivFlexCenEnd>
                  <InputTextField name={'min'} type={'number'} min="0" max="100" defaultValue={Math.floor(inputQuestionSetPrintTimeAndScore.timeSec/60)}/>
                  <SpanTextSecondaryXS style={{padding: '0.125rem'}}>分</SpanTextSecondaryXS>
                  <InputTextField name={'sec'} type={'number'} min="0" max="59" defaultValue={inputQuestionSetPrintTimeAndScore.timeSec%60}/>
                  <SpanTextSecondaryXS style={{padding: '0.125rem'}}>秒</SpanTextSecondaryXS>
                  <InputTextField name={'missCount'} type={'number'} min="0" max="25" defaultValue={inputQuestionSetPrintTimeAndScore.missCount}/>
                  <SpanTextSecondaryXS style={{padding: '0.125rem'}}>ミス</SpanTextSecondaryXS>
                </DivFlexCenEnd>
                {
                  errorMessages.length > 0
                  && <>
                    { errorMessages.map((errorMessage, index) => (
                        <PErrorMessage key={index}>
                          {errorMessage}
                        </PErrorMessage>
                      ))
                    }
                  </>
                }
                <InputSubmitButton value={ isLoading ? '記録中...' : '記録'} type="submit" disabled={isLoading}/>
              </form>
            </>
          }
        </>
      </Modal>
      <Modal
        isModalShow={deleteQuestionSetPrintTimeAndScore != null}
        closeAction={() => setDeleteQuestionSetPrintTimeAndScore(null)}
      >
        <>
        {
          deleteQuestionSetPrintTimeAndScore != null &&
          <>
            <PTextPrimaryM style={{margin: '0 0 0.5rem 0'}}>
              {questionSet.title}
            </PTextPrimaryM>
            <PTextPrimaryS>
              {deleteQuestionSetPrintTimeAndScore.date}
            </PTextPrimaryS>
            <PTextPrimaryS>
              {String(Math.floor(deleteQuestionSetPrintTimeAndScore.timeSec/60)).padStart(2, '0')}<SpanTextSecondaryS>分</SpanTextSecondaryS>{String(deleteQuestionSetPrintTimeAndScore.timeSec%60).padStart(2, '0')}<SpanTextSecondaryS>秒</SpanTextSecondaryS>
              {deleteQuestionSetPrintTimeAndScore.missCount}<SpanTextSecondaryS>ミス</SpanTextSecondaryS>
            </PTextPrimaryS>
            <PTextPrimaryL style={{margin: '1rem 0 1rem 0'}}>
            本当に削除しますか？
          </PTextPrimaryL>
          <APrimaryOrangeButton onClick={timeAndScoreDelete}>
            削除する
            </APrimaryOrangeButton>
          </>
        }
        </>
      </Modal>
    </>
  )
};

const DivWhiteBackGround = styled.div`
  background-color: #fff;
  position: sticky;
  top: 4.7rem;
  z-index: 100;
  background-color: ${SHADOW_PRIMARY};
`;

const DivButtonWrap = styled.div`
`;

const DivShadowBox = styled.div`
  background-color: ${LIGHT_GRAY};
  padding: 0.5rem 1rem;
`
const DivRecordsWrap = styled.div`
  margin: 2rem 0 0 0;
  padding: 3rem 1rem 2rem;
  border-top: 1px solid ${BORDER_SECONDARY};
`
const DivAdviceWrap = styled.div`
  margin: 2rem 0 0 0;
  padding: 3rem 1rem 2rem;
  border-top: 1px solid ${BORDER_SECONDARY};
`
